import React from 'react';

export default function DiscreteSelectBox(props) {
  const { options, selected, onChange, questionKey } = props;
  const handleChange = (e) => {
    const optionValue = parseInt(e.target.value);
    let array = [optionValue];
    if(optionValue === '') {
      array = [];
    }
    onChange(questionKey, array);
  };

  return (
    <div className="col-md-6 text-left" key={questionKey}>
      <select
        className="form-input"
        value={selected[questionKey]}
        onChange={handleChange}
      >
        <option value="">-- Select --</option>
        {options.map((opt, idx) => (
          <option key= {idx} value={opt.PK_ID}>{opt.VALUE}</option>
        ))}
      </select>
    </div>
  );
}